import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class DarkModeService {
  private darkMode = new BehaviorSubject<boolean>(false);
  darkMode$: Observable<boolean> = this.darkMode.asObservable();

  private isMobileDevice = false;
  private isBrowser: boolean;

  constructor(@Inject(PLATFORM_ID) private platformId: Object) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  /**
   * ✅ Call this manually from AppComponent (browser only)
   */
  init() {
    if (!this.isBrowser) return;

    this.isMobileDevice = this.checkIfMobileDevice();

    let initialValue = false;

    const saved = localStorage.getItem('DarkMode');

    if (saved !== null) {
      initialValue = saved === 'true';
    } else {
      initialValue = this.isSystemDarkMode();
    }

    this.darkMode.next(initialValue);

    if (this.isMobileDevice) {
      this.detectSystemTheme();
    }
  }

  private isSystemDarkMode(): boolean {
    if (!this.isBrowser) return false;
    return window.matchMedia('(prefers-color-scheme: dark)').matches;
  }

  private detectSystemTheme(): void {
    if (!this.isBrowser) return;

    const mq = window.matchMedia('(prefers-color-scheme: dark)');

    this.setDarkMode(mq.matches);

    mq.addEventListener('change', (event) => {
      this.setDarkMode(event.matches);
    });
  }

  private checkIfMobileDevice(): boolean {
    if (!this.isBrowser) return false;
    return window.matchMedia('(max-width: 1023px)').matches;
  }

  isMobile(): boolean {
    return this.isMobileDevice;
  }

  toggleDarkMode(): void {
    const newValue = !this.darkMode.value;
    this.setDarkMode(newValue);
  }

  setDarkMode(isDarkMode: boolean): void {
    this.darkMode.next(isDarkMode);

    if (this.isBrowser) {
      localStorage.setItem('DarkMode', isDarkMode.toString());
    }
  }
}